import { Dispatch } from 'react';
import { TableAction, TableAsyncActions } from '../actions';
import { TableState } from '../types';

export const createTableMiddleware = <T>(
  asyncActions: TableAsyncActions,
  getState: () => TableState<T>
) => {
  return (next: Dispatch<TableAction>) => (action: TableAction) => {
    // Appeler d'abord le reducer pour mettre à jour l'état
    next(action);

    if (process.env.NODE_ENV === 'development') {
      // console.log('[Table Action]', action);
    }

    // Actions qui déclenchent un re-fetch automatique
    const actionsThatTriggerFetch = [
      'SET_CURRENT_PAGE',
      'SET_PAGE_SIZE',
      'SET_SEARCH_STRING',
      'CLEAR_SEARCH',
      'SET_SORTING',
      'CLEAR_SORTING',
      'SET_FILTER',
      'REMOVE_FILTER',
      'CLEAR_FILTERS'
    ];

    if (actionsThatTriggerFetch.includes(action.type)) {
      // Utiliser un setTimeout pour permettre au state de se mettre à jour
      setTimeout(() => {
        asyncActions.fetchDataAsync();
      }, 0);
    }

    return action;
  };
};
